import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';

export const NoteText = ({ text }) => {
  return (
    <div className="note">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.418"
        height="17.651"
        viewBox="0 0 15.418 17.651"
      >
        <g
          id="written-conversation-speech-bubble-with-letter-i-inside-of-information-for-interface"
          transform="translate(-1.811)"
        >
          <path
            id="Path_771"
            data-name="Path 771"
            d="M9.52,0A7.709,7.709,0,0,0,5.807,14.465l-.091,3.186,3.637-2.242c.055,0,.11.009.166.009A7.709,7.709,0,0,0,9.52,0ZM10.5,12.2H8.526V5.843H10.5Zm-1-7.137a.966.966,0,0,1-1.027-.989.966.966,0,0,1,1.04-1A1,1,0,1,1,9.5,5.064Z"
            fill="#f18926"
          />
        </g>
      </svg>
      <Typography.Text className="noteText">{text}</Typography.Text>
    </div>
  );
};

NoteText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NoteText;
